export default {
  methods: {
    outputCSV($type) {
      let query_params = this.getParams()
      let conditions = {}

      _.forEach(query_params, function(value, key) {
        if (key !== 'type') {
          conditions[key] = value
        }
      })

      let total_query_str = `conditions=${encodeURIComponent(JSON.stringify(conditions))}&type=${$type}`

      window.location.href = `${process.env.VUE_APP_API_URL}/sale/api/v1/bukkens/csv/download?${total_query_str}`
    },
  },
}
